import { SelectionMode } from '@fluentui/react';
import { DetailsRow } from 'office-ui-fabric-react';
import { DetailsRowFields } from "office-ui-fabric-react/lib/components/DetailsList/DetailsRowFields";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { NotificationsTarget, useNotificationsManager } from '../../contexts/notificationContext';
import { DataNiveauAlerte } from "../../data/DataNiveauAlerte";
import { Immocom } from '../../specifique/immocom';
import { EUIDetailsList } from '../EUI/EUIDetailsList';

const DetailsListNiveauAlerte = (props) => {

    // CONTEXTS
    const { dismiss, extract, load } = useNotificationsManager();

    // PROPS
    const {
        activeItems = [], // liste des lots à présélectionner
        idTypeMandat = undefined,
        onSelectionChanged = items => null,  // renvoi la liste des lots sélectionnés
        selectionMode = SelectionMode.multiple,
        wrapInScrollablePane = true,
    } = props;

    // CONSTANTES

    // STATES
    const [_items, _setItems] = useState([]);

    // REFS

    // MEMOS

    // METHODS
    const _chargementDonnees = useCallback(() => {
        const id = load("Chargement des niveaux d'alertes en cours...");
        DataNiveauAlerte._listeDesNiveauxAlertesParTypeMandat(idTypeMandat).then(response => {
            const onSuccess = () => {
                const items = response.reponseAPIobjet || [];
                _setItems(items);
            };
            const onError = (result) => extract(result, NotificationsTarget.main);
            Immocom.checkFetchResponse(response, onSuccess, onError);
            dismiss(id);
        });
    }, [idTypeMandat]);

    const _onSelectionChanged = useCallback((items) => {
        if (typeof onSelectionChanged === "function")
            onSelectionChanged(items);
    }, [onSelectionChanged]);

    const _onRenderRow = useCallback((props, defaultRender) => {
        // Permet de désactiver la sélection de la ligne
        return <DetailsRow
            {...props}
            rowFieldsAs={(fieldProps) =>
                <span data-selection-disabled={selectionMode === SelectionMode.none}>
                    <DetailsRowFields {...fieldProps} />
                </span>
            }
        />;
    }, [selectionMode]);

    // EFFECTS (ComponentDidMount + ComponentDidUpdate)
    // Recharger les données lorsque idTypeMandat change
    useEffect(() => {
        if (!!idTypeMandat)
            _chargementDonnees();
    }, [idTypeMandat]);

    // UI
    const _columns = useMemo(() => {
        return [
            {
                key: "idNiveauAlerte",
                maxWidth: 30,
                minWidth: 30,
            }, {
                key: "niveauAlerte",
                maxWidth: 230,
                minWidth: 100,
                name: "Alertes sur le périmètre",
            }
        ];
    }, []);

    // RENDER
    return <EUIDetailsList
        activeItems={activeItems}
        columns={_columns}
        getKey={item => item.idNiveauAlerte}
        hideCommandBar
        items={_items}
        onRenderRow={_onRenderRow}
        onSelectionChanged={_onSelectionChanged}
        selectionMode={selectionMode}
        wrapInScrollablePane={wrapInScrollablePane}
    />;

};

export default DetailsListNiveauAlerte;